import type { ComponentProps } from 'react'
import React, { useState } from 'react'
import { Label } from '~/design-system/primitives'
import { cn } from '~/lib/cn'

type HolderNameInputProps = {
  onNameChange?: (name: string) => void
} & ComponentProps<'input'>

const HolderNameInput: React.FC<HolderNameInputProps> = ({ onNameChange, ...props }) => {
  const [isValid, setIsValid] = useState(true)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const valueWithoutNumbers = event.target.value.replace(/[0-9]/g, '')

    /*
     * Validation: valida se existem dois nomes separados por espaço com mínimo de 2 caracteres
     */
    const regex = /^\s*[A-Za-zÀ-ÿ]+(?: [A-Za-zÀ-ÿ]+)+\s*$/
    setIsValid(regex.test(valueWithoutNumbers))

    onNameChange?.(valueWithoutNumbers)

    event.target.value = valueWithoutNumbers
  }

  return (
    <>
      <Label className="" htmlFor="name">
        Nome do titular *
      </Label>

      <input
        className={cn(
          'w-full px-2 py-1.5 min-w-0 outline bg-white text-sm text-gray-800 disabled:text-primary-black max-h-9 border rounded border-gray-60 outline-0',
          !isValid && 'border border-red-700',
        )}
        id="name"
        maxLength={40}
        name="name"
        type="text"
        required
        onChange={handleChange}
        {...props}
      />

      <div>
        {!isValid ? (
          <p className="text-red-700 text-sm">Por favor insira pelo menos dois nomes sem números.</p>
        ) : (
          <p className="text-sm text-gray-80">Nome completo do titular do cartão</p>
        )}
      </div>
    </>
  )
}

export default HolderNameInput
